







































import StakingViewPrograms from './StakingViewPrograms.vue';
import StakingViewInfoTiles from './StakingViewInfoTiles.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { enableOperatorFeatureFlag } from '@/api/FeatureFlags';
import type { PropType } from 'vue';
import { ELoyaltyFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';

export default {
  name: 'StakingView',
  props: {
    modal: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    }
  },
  components: {
    StakingViewPrograms,
    StakingViewInfoTiles
  },
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    ...mapGetters('FeatureFlags', ['featureFlagByName', 'isFeaturesLoading']),
    h2eFlag(): boolean {
      return this.featureFlagByName(ELoyaltyFeatureFlag.HOLD_TO_EARN) ?? {};
    },
    disableStaking(): boolean {
      return !this.h2eFlag.name || !this.$role.can.update('h2e');
    }
  },
  methods: {
    ...mapActions('FeatureFlags', ['getOperatorLoyaltyFeatureFlags']),
    changeHandler(switchStatus: boolean): void {
      if (!this.h2eFlag.name) {
        return;
      }

      enableOperatorFeatureFlag(this.h2eFlag.featureFlagId, switchStatus)
        .then((): void => {
          this.$toast.success(
            `Hold to Earn has been turned ${switchStatus ? 'on' : 'off'}`
          );

          this.getOperatorLoyaltyFeatureFlags();
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        });
    }
  }
};
